import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import { Input as BaseInput } from "@/ui-lib/FormFields";

import styles from "./Input.module.scss";

const Input = ({
  id,
  containerClassName,
  className,
  errorMessageClassName,
  errors,
  withoutError,
  invalid,
  ...props
}) => {
  const error = !!(errors[id] || invalid) && !withoutError;

  const handleFocus = (e) => {
    const { autoSelected, onFocus } = props;

    if (autoSelected) {
      e.target.select();
    }

    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = (e) => {
    const { onBlur, setFieldValue, setFieldTouched } = props;
    const { value } = e.target;

    setFieldValue(id, value || "");
    setFieldTouched(id, true);

    if (onBlur) {
      onBlur(id, value);
    }
  };

  const handleChange = (e) => {
    const { onChange, setFieldValue } = props;
    const { value } = e.target;

    setFieldValue(id, value || "");

    if (onChange) {
      onChange(id, value);
    }
  };

  return (
    <div
      className={cx(
        styles.inputContainer,
        error && errors[id] && props.touched[id] ? styles.inputError : "",
        containerClassName
      )}
    >
      <BaseInput
        {...props}
        id={id}
        className={cx(className)}
        onFocus={handleFocus}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {error && errors[id] && props.touched[id] && (
        <div className={cx(styles.errorMessage, errorMessageClassName)}>{errors[id]}</div>
      )}
    </div>
  );
};

Input.defaultProps = {
  setFieldTouched: () => null,
  setFieldValue: () => null,
  onFocus: () => null,
  onChange: () => null,
  onBlur: () => null,
  withoutError: false,
  invalid: false,
  errors: {},
  containerClassName: "",
  className: "",
  errorMessageClassName: "",
  autoSelected: false,
};

Input.propTypes = {
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  id: PropTypes.string.isRequired,
  withoutError: PropTypes.bool,
  invalid: PropTypes.bool,
  errors: PropTypes.shape({}),
  containerClassName: PropTypes.string,
  className: PropTypes.string,
  errorMessageClassName: PropTypes.string,
  autoSelected: PropTypes.bool,
};

export default Input;
